/**
 * Whether the company setting lets a user with these roles see loaded hourly costs
 * (coûts horaires chargés). Pure so the precedence stays pinned by unit tests — see
 * `useSalaryCostsAccess` for how it is wired and why a missing setting denies.
 */
export function canSeeSalaryCosts(params: {
  isCompanyAdmin: boolean;
  isGroupAdmin: boolean;
  groupAdminSalaryCostsVisible: boolean | undefined;
}): boolean {
  if (params.isCompanyAdmin || !params.isGroupAdmin) return true;
  return params.groupAdminSalaryCostsVisible === true;
}
